import { auth } from '@/plugins/Firebase';
import "@/types"

const _auth:Auth = {
  user: {
    uid: null,
    permissions: []
  },
  token: {
    claims: {}
  } as any
}

export default {
  namespaced: true,
  
  state: _auth,

  mutations: {
    setMethods: (state:Auth, methods:string[]) => {
      state.signInMethods = methods
    },
    setUser: (state:Auth, user:Auth["user"]) => {
      user != undefined ? state.user = user : state = _auth
    },
    setToken: (state:Auth, token:firebase.auth.IdTokenResult) => {
      token != undefined ? state.token = token : state = _auth
    },
  },

  actions: {
    signOut({ commit }) {
      commit('setUser')
      commit('setUser', null, {root: true})
      commit('setToken')
      auth.signOut()
    },
    setMethods({ commit }, methods:string[]) {
      commit('setMethods', methods)
    },
    setToken({ commit }, token:firebase.auth.IdTokenResult) {
      commit('setToken', token)
    },
    setUser({ commit }, user:Auth["user"]) {
      commit('setUser', user)
    },
  },

  getters: {

  }
}